import axios from 'axios'

const STORAGE_KEY = 'yuanzhu_firstV'
const CHECK_INTERVAL = 1000 * 60 * 5

// 独立实例，避免 plugins/axios.js 注入 shm-* 请求头和响应转换
const http = axios.create({ timeout: 10000 })

let firstV = JSON.parse(window.localStorage.getItem(STORAGE_KEY)) || []
let checking = false
let listenerAttached = false

async function getHtmlFun() {
  const res = await http.get(`${window.location.origin}/?date=${Date.now()}`)
  if (res.status === 200 && res.data) {
    const reg = /<script(?!.*src=['"](http|https):\/\/[^'"]*['"])(?=.*src=['"][^'"]*\.js['"])[^>]*><\/script>/gi
    return res.data.match(reg) || []
  }
  return []
}

function isEqual(a, b) {
  return a.length === Array.from(new Set(a.concat(b))).length
}

async function fetchAndCompare(callback) {
  if (checking) return
  checking = true
  try {
    const currentV = await getHtmlFun()
    if (!firstV.length) {
      firstV = currentV
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(firstV))
      return
    }
    if (!isEqual(firstV, currentV)) {
      firstV = currentV
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(firstV))
      callback()
    }
  } catch (e) {
    console.warn('[verChange] version check failed:', e.message)
  } finally {
    checking = false
  }
}

function startPolling(callback) {
  window.checkVersionInterval && clearInterval(window.checkVersionInterval)
  window.checkVersionInterval = setInterval(() => fetchAndCompare(callback), CHECK_INTERVAL)
}

export function visibilitychangeFun(callback) {
  if (listenerAttached) return
  listenerAttached = true

  fetchAndCompare(callback).then(() => startPolling(callback))

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      fetchAndCompare(callback)
      startPolling(callback)
    } else {
      window.checkVersionInterval && clearInterval(window.checkVersionInterval)
    }
  })
}
